// extracted by mini-css-extract-plugin
export default {"colorViolet":"#080837","colorLoblolly":"#C5D0D8","smBreak":"600px","wrapGap":"8px","crumbMargin":"12px","breadcrumb":"sR6u6Arlwbt46mmFHmNu"};